import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    year: Yup.string() 
      .matches(/^[0-9]{4}$/, 'Year must be exactly 4 digits') 
      .required('Year is required'),
    month: Yup.number().min(1).max(12).required('Month is required'),
  });